// extracted by mini-css-extract-plugin
export default {"loading":"Loading_loading__i-r5i","spinner":"Loading_spinner__+riZL","spin":"Loading_spin__H4DyZ"};